import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import ChatSlice from "./reducers/ChatSlice";
import { Api } from "./api/BaseApi";
import { reducer as oidcReducer, loadUser } from 'redux-oidc';
import userManager from "../settings/oAuthSettings";
import SignalRMiddleware from "./middleware/SignalRMiddleware";
import { ChatApi } from "./api/ChatApi";
import ticketViewMiddleware from "./middleware/TicketViewMiddleware";
import ticketViewSlice from "./reducers/TicketViewSlice";

export const store = configureStore({
  reducer: {
    auth: oidcReducer,
    chat: ChatSlice.reducer,
    [Api.reducerPath]: Api.reducer,
    [ticketViewSlice.name]: ticketViewSlice.reducer
  },
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false //Stop OIDC serializable warnings
    }).concat([ChatApi.middleware, SignalRMiddleware, ticketViewMiddleware])
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

//OAuth
loadUser(store, userManager);


export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
